export default "/build/images/logo-arabic.png?5872c5bec8168d809cae7343809115e5";